export default Route => {
  // 登录页
  Route.view("/login", () =>
    import(/* webpackChunkName: "login" */ "../views/login/index.vue")
  ).options({
    name: "login",
    meta: {
      layout: "empty",
      navTransparent: true,
      hideNav: true
    }
  });
  // 注册页
  Route.view("/register", () =>
    import(/* webpackChunkName: "login" */ "../views/register/index.vue")
  ).options({
    name: "register",
    meta: {
      layout: "empty",
      navTransparent: true,
      hideNav: true
    }
  });
};
